<template>
  <el-dialog custom-class="max-dialog1256" title="订单信息" :visible.sync="dialogFormVisible" center :append-to-body="true"
             :close-on-click-modal="false"
  >
    <div>
      <el-col :span="24">
        <div>
          <div class="search-content">
            <el-col :span="24" class="toobar">
              <el-col :span="5">
                <el-select v-model="independentserial" @change="bindGrid()" filterable size="medium">
                  <el-option v-for="item in idd" :key="item.serialnum"
                             :label="item.dname"
                             :value="item.serialnum">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="5">
                <el-input placeholder="请输入订单号" v-model="searchdata" size="medium" style="width: 200px"
                          clearable></el-input>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-search" @click="bindGrid">搜索</el-button>
              </el-col>
            </el-col>
          </div>

          <el-table
            :data="tableData"
            :height="tableHeight(210)"
            size="mini"
            stripe
            border
            style="width: 100%;"
            @selection-change="handleSelectionChange">
            <el-table-column
              width="60"
              label="序号"
              align="center">
              <template slot-scope="scope">
                {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
              </template>
            </el-table-column>
            <el-table-column
              prop="erpserial"
              label="订单号"
              align="center"
              header-align="center"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="htqd"
              label="下单时间"
              align="center"
              header-align="center"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="customername"
              label="客户"
              align="left"
              header-align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              prop="logisticsco"
              label="快递公司"
              align="center"
              header-align="center"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="logisticsnum"
              label="快递单号"
              align="center"
              header-align="center"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="yfk"
              label="金额"
              align="right"
              header-align="center"
              width="100"
            >
              <template slot-scope="scope">
                {{scope.row.yfk|numeric(2)}}
              </template>
            </el-table-column>
            <el-table-column
              prop="handleoverdate"
              label="办结日期"
              align="center"
              header-align="center"
              width="140"
            >
            </el-table-column>
            <el-table-column
              prop="isreturnorder"
              label="是否退货"
              align="center"
              header-align="center"
              width="100"
            >
              <template slot-scope="scope">
                {{scope.row.isreturnorder==-1?'已退货':''}}
              </template>
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              header-align="center"
              width="100"
            >
              <template slot-scope="scope">
                {{zhuangtai(scope.row.status)}}
              </template>
            </el-table-column>
          </el-table>
          <!--<div class="foot" style="text-align: center;">-->
            <!--<Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>-->
          <!--</div>-->

        </div>

      </el-col>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button type="warning" v-on:click="SelectOK">发货</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {independentDept} from '@/api/set/dept';
  import {
    getCstagreementListDataNew, scanningfahuo
  } from '@/api/set/csagreement';


  export default {
    name: 'HelloWorld',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        independentserial: '',
        searchdata: '',
        idd: [],//服务中心
        SelectionChange: [],//
        statuses: "",//状态
        logisticsnum: "",//快递单号
        loading: true,
        pagination: {
          currentPage: 1,
          pageSize: 1000,
          total: 0
        },
        tableData: [],
      }
    },
    methods: {
      //状态
      zhuangtai(status) {
        if (status == 300) {
          return '待加工'
        } else if (status == 350) {
          return '待发货'
        } else if (status == 400) {
          return '待配送'
        } else if (status == 500) {
          return '已发货'
        } else if (status == 750) {
          return '已退款'
        } else {
          return ""
        }
      },
      handleSelectionChange(val) {
        this.SelectionChange = val;
      },
      SelectOK() {//确认发货
        this.$confirm('是否确定发货?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          scanningfahuo({formtype: 72, orderList: JSON.stringify(this.tableData)}).then(response => {
            this.$message({
              message: response.data.msg,
              type: 'success'
            })
          })
          //刷新列表
          this.$emit("bindGrid")
          this.dialogFormVisible = false;

        }).catch(() => {
          this.$message({
            duration: 1500,
            type: 'info',
            message: '已取消作废'
          });
        });

      },
      show(logisticsnum,status) {
        this.dialogFormVisible = true;
        this.initform()
        this.logisticsnum = logisticsnum
        this.status=status
        this.bindGrid()
      },
      //数据源
      bindGrid() {
        getCstagreementListDataNew({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          search: this.searchdata.trim(),
          independentserial: this.independentserial,
          status: this.status,
          logisticsnum: this.logisticsnum
        }).then(response => {
          this.tableData = response.data.obj.rows
          this.pagination.total = response.data.obj.total
        }).catch((error) => {
          // this.$message.error(JSON.stringify(error))
        });
      },

      initform() {
        this.searchdata = ''
      }


    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      if (!this.userInfoModel.independentserial) {
        this.idd.unshift({serialnum: "all", dname: "全部"})
        this.independentserial = "all"
      } else {
        this.independentserial = this.userInfoModel.independentserial
      }
      independentDept().then(response => {
        this.idd = this.idd.concat(response.data.obj)
      })
    },
    components: {}

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/InvoiceList.vue